// removed by extract-text-webpack-plugin
module.exports = {"monospace-font-family":"'Roboto Mono', monospace"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Terminal.css
// module id = 559
// module chunks = 2